import { SelectButtonDark } from 'components/button/button.styled'
import { Spinner } from 'components/loadingContainer/LoadingContainer.styled'
import { PlaceholderContainer } from 'components/placeholder'
import { useSelectedEventForScan } from 'context/SelectedEventForScan'
import { useEventDetailsForScan } from 'hooks/admin/useEvents/useEventDetailsForScan'
import { Dropdown } from 'primereact/dropdown'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { CardGrid, CardText, Container, Filters, StyledCard } from './scanEventSelector.style'
import { StyledCalendar } from './ticketScan.style'

export const ScanEventSelector = () => {
    const { eventDetails, isLoading, error } = useEventDetailsForScan()
    const [selectedLocation, setSelectedLocation] = useState<string | null>(null)
    const [selectedDate, setSelectedDate] = useState<Date | null>(null)
    const { selectedEventId, setSelectedEventId } = useSelectedEventForScan()
    const navigate = useNavigate()

    const locationOptions = useMemo(() => {
        const unique = new Map()
        eventDetails.forEach((event) => {
            if (event.location?.name) {
                unique.set(event.location_id, event.location.name)
            }
        })
        return Array.from(unique.entries()).map(([id, name]) => ({ label: name, value: id }))
    }, [eventDetails])

    const filteredEvents = useMemo(() => {
        const today = new Date()
        return eventDetails
            .filter((event) => {
                const matchesLocation = !selectedLocation || event.location_id === selectedLocation
                const matchesDate = !selectedDate || new Date(event.event_date).toDateString() === selectedDate.toDateString()
                return matchesLocation && matchesDate
            })
            .sort((a, b) => {
                const diffA = Math.abs(new Date(a.event_date).getTime() - today.getTime())
                const diffB = Math.abs(new Date(b.event_date).getTime() - today.getTime())
                return diffA - diffB
            })
    }, [eventDetails, selectedLocation, selectedDate])

    if (isLoading) return <Spinner />
    if (error)
        return (
            <PlaceholderContainer>
                <p>Jelenleg nincs esemény, amely megfelel a feltételeknek.</p>
            </PlaceholderContainer>
        )

    return (
        <Container>
            <Filters>
                <Dropdown
                    value={selectedLocation}
                    options={locationOptions}
                    onChange={(e) => setSelectedLocation(e.value)}
                    placeholder="Szűrés helyszínre"
                    className="w-64"
                    showClear
                />

                <StyledCalendar
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.value as Date)}
                    placeholder="Szűrés időpontra"
                    dateFormat="yy-mm-dd"
                    showIcon
                    showButtonBar
                />
            </Filters>

            <CardGrid>
                {filteredEvents.map((event) => {
                    const isSelected = selectedEventId === event.event_id
                    return (
                        <StyledCard key={event.event_id} title={event.show?.name}>
                            <CardText>{event.location?.name}</CardText>
                            <CardText>{new Date(event.event_date).toLocaleDateString('hu-HU')}</CardText>
                            <SelectButtonDark
                                type="button"
                                icon="pi pi-arrow-right"
                                onClick={() => {
                                    setSelectedEventId(event.event_id)
                                    navigate('/admin/jegyellenorzes')
                                }}
                                selected={isSelected}
                                style={{ alignSelf: 'end' }}
                            />
                        </StyledCard>
                    )
                })}
            </CardGrid>
        </Container>
    )
}
